const version = {
  "api-version": "24",
  "app-version": "1.1.25",
  agent: "WEB",
};

export default version;
